module.exports = __webpack_public_path__ + "img/horizontal_7_5_9006.6a71ec89.png";